import { render, staticRenderFns } from "./SoilCharacteristics.vue?vue&type=template&id=192a0de8"
import script from "./SoilCharacteristics.vue?vue&type=script&lang=js"
export * from "./SoilCharacteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports